// src/logs/logFrequency.js — ONE home for the weekly-log rules, shared by the
// logs screen and the Checks screen's Daily-logs card (both bundles inline it).
//
// THE RULE (Matt, 9 Aug 2026 — supersedes v125.31's Monday-only visibility):
// a weekly log type (frequency='weekly', e.g. the Top 10 Stock Check) can be
// done ANY day of the week, is DUE on Monday, and is needed ONCE per week.
// So it is VISIBLE every day; its state is judged against the Mon–Sun week
// of the viewed date: an entry anywhere in that week satisfies it, no entry
// on a Monday means "due today", and no entry after Monday means overdue.
//
// History: v125.31 hid weekly types except Mondays; v129.96 first unified the
// two surfaces on that rule, then Dubai Mall 2's report surfaced what stores
// actually needed ("they can do it any day... due on a Monday") and Matt
// re-ruled. Daily templates (or no frequency) are untouched throughout.

export function isWeeklyLog(t) {
  return String((t && t.frequency) || 'daily').toLowerCase() === 'weekly';
}

// The Mon–Sun week containing dateStr ('YYYY-MM-DD'). Weekly logs are due on
// Monday, so the compliance week is ISO Mon-anchored for every store — this
// is a LOG rule, deliberately independent of the rota's country week anchors.
export function logWeekRange(dateStr) {
  var d = new Date(String(dateStr) + 'T12:00:00Z');
  var backToMon = (d.getUTCDay() + 6) % 7;   // 0 on Monday … 6 on Sunday
  var mon = new Date(d); mon.setUTCDate(d.getUTCDate() - backToMon);
  var sun = new Date(mon); sun.setUTCDate(mon.getUTCDate() + 6);
  return { from: mon.toISOString().slice(0, 10), to: sun.toISOString().slice(0, 10) };
}

// Pure: the weekly state for the viewed date given how many entries exist in
// that date's week. Label text is user-facing on both surfaces.
export function weeklyLogStatus(dateStr, weekEntryCount) {
  if ((weekEntryCount || 0) > 0) return { state: 'done', label: '🟢 Done this week' };
  var isMonday = new Date(String(dateStr) + 'T12:00:00Z').getUTCDay() === 1;
  if (isMonday) return { state: 'due', label: '⚠️ Due today' };
  return { state: 'overdue', label: '🔴 Overdue — was due Monday' };
}
